// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2-c2y","tabContainer":"styles_tabContainer__2XGey","tab":"styles_tab__X4o1m","header":"styles_header__2PuCW","active":"styles_active__20ojI"};